import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCenterLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/center" */ './Center'), 'CenterLayout');
